export default {
    data(){
      return {
        isLoadingExpiration: true,
        expirationSoon: []
      }
    },
  
    computed: {
      user() {
        return this.$store.state.auth.user;
      }
    },
  
    methods: {
      async loadExpirationSoon(){
        this.isLoadingExpiration = true;
        let rs = await this.$api.cpd.expirationSoon().call();
        if (rs.success) this.expirationSoon = rs.response.result;
        this.isLoadingExpiration = false;
      },

      getCpdIds(items){
        return items.map((item) => item.id).join(',');
      }
    },
  
    mounted() {
      this.loadExpirationSoon();
    },
}